import { Routes } from '@angular/router';
import { MasterComponent } from './components/master/master.component';
import { environment } from '../environments/environment';

const childrenRoutes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },

  {
    path: 'main',
    loadChildren: () =>
      import('./components/main/main.routing')
        .then(r => r.mainRoutes)
  },

  {
    path: 'registration',
    loadChildren: () =>
      import('./components/registration/registration.routing')
        .then(r => r.registrationRoutes)
  },

  {
    path: 'wallet',
    loadChildren: () =>
      import('./components/wallet/wallet.routes')
        .then(r => r.walletRoutes)
  },

  {
    path: 'profile',
    loadChildren: () =>
      import('./components/profile/profile.routes')
        .then(r => r.profileRoutes)
  },

  {
    path: '',
    loadChildren: () =>
      import('./components/survey/surveys.routing')
        .then(r => r.surveysRoutes)
  },

  {
    path: 'language',
    loadComponent: () =>
      import('./components/language/language.component')
        .then(c => c.LanguageComponent)
  }
];

if (environment.featureFlags.chat) {
  childrenRoutes.push({
    path: 'chat',
    loadChildren: () =>
      import('./components/chat/chat.routing')
        .then(r => r.chatRoutes)
  });
}

export const routes: Routes = [
  {
    path: '',
    component: MasterComponent,
    children: childrenRoutes
  },

  {
    path: '**',
    redirectTo: 'main'
  }
];
